import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TSwissDeclarationsRow } from './types';

export const tableStructure: TTableStructure<keyof TSwissDeclarationsRow, TSwissDeclarationsRow>[] =
	[
		{
			name: 'ID',
			selector: 'id',
			show: false,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.NUMBER,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Created At',
			selector: 'createdAt',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.DATE_TIME,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'File Name',
			selector: 'fileName',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.TEXT,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Registration Number',
			selector: 'registrationNumber',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'MRN',
			selector: 'mrn',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Decision Date',
			selector: 'decisionDate',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.DATE_TIME,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Reference Number',
			selector: 'referenceNumber',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'External ID',
			selector: 'externalId',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 2,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Actions',
			selector: 'actions',
			noName: true,
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.BUTTONS,
			align: ETableStructureAlign.LEFT,
			buttons: [{ name: 'Download', icon: EIconButtons.DOWNLOAD }],
		},
	];
